import { ReactComponent as BookIcon } from "./../assets/book.svg";
import { ReactComponent as CalendarIcon } from "./../assets/calendar.svg";
import { ReactComponent as DateIcon } from "./../assets/calendar_30.svg";
// import { ReactComponent as ChatIcon } from './../assets/chat.svg';
import { ReactComponent as MessageIcon } from "./../assets/messaging.svg";
import { ReactComponent as FirstAidIcon } from "./../assets/doctors_bag.svg";
import { ReactComponent as MailBoxIcon } from "./../assets/post_box.svg";
import Calendar from "./../assets/additional/calendar.webp";
import AppointmentLogo from "./../assets/additional/appointment.webp";
import Cases from "./../assets/additional/cases.png";
import Discussion from "./../assets/additional/chat.webp";
import Clinics from "./../assets/additional/home-icon.png";
import Knowledge from "./../assets/additional/teeth-icon.webp";
import { FaTeethOpen } from "react-icons/fa";
import AlignerScheduleImage from "./../assets/aligner-schedule.svg";

export const sidebarItems = [
  {
    icon: CalendarIcon,
    title: "Calendar",
    des: "Schedule of Treatments",
    image: Calendar,
    link: "/calendar",
  },
  {
    icon: DateIcon,
    title: "Appointment",
    // des: "Book of Treatments",
    des: "See latest appointment",
    image: AppointmentLogo,
    // link: "/appointment",
    link: "/appointment-view",
  },
  {
    icon: FaTeethOpen,
    title: "Aligner Schedule",
    des: "Aligner switching schedule",
    image: AlignerScheduleImage,
    link: "/aligner-schedule",
  },
  {
    icon: MailBoxIcon,
    title: "Cases",
    des: "Treatment history",
    image: Cases,
    link: "/cases",
  },
  {
    icon: MessageIcon,
    title: "Discussions",
    des: "Collaborative on Cases",
    image: Discussion,
    link: "/discussion",
  },
  {
    icon: FirstAidIcon,
    title: "Clinics",
    des: "Nearby Clinic and Doctors",
    image: Clinics,
    link: "/clinic",
  },
  {
    icon: BookIcon,
    title: "Knowledge",
    des: "All About Orthodontics",
    image: Knowledge,
    link: "/knowledge",
  },
];
